import React from 'react';
import { View, ViewStyle, StyleProp, StyleSheet } from 'react-native';
import { layout } from '../../styles/layout';

interface SectionContainerProps {
    children: React.ReactNode;
    /** Override the default horizontal padding */
    paddingH?: number;
    /** Additional styles merged onto the container View */
    style?: StyleProp<ViewStyle>;
    /** If true, remove vertical padding (for hero sections with their own padding) */
    noPaddingY?: boolean;
}

/**
 * SectionContainer — mandatory wrapper for every page section.
 *
 * Guarantees:
 * - maxWidth: 1440 (layout.maxWidth)
 * - paddingHorizontal: 80 (web) / 24 (mobile)
 * - centered with marginHorizontal: 'auto'
 * - 100% width
 *
 * Usage:
 * ```tsx
 * <SectionContainer>
 *   <Typography variant="h2">Section Title</Typography>
 *   ...
 * </SectionContainer>
 * ```
 */
export const SectionContainer: React.FC<SectionContainerProps> = ({
    children,
    paddingH,
    style,
    noPaddingY,
}) => (
    <View
        style={[
            styles.container,
            paddingH != null && { paddingHorizontal: paddingH },
            noPaddingY && { paddingVertical: 0 },
            style,
        ]}
    >
        {children}
    </View>
);

const styles = StyleSheet.create({
    container: {
        maxWidth: layout.maxWidth,
        marginHorizontal: 'auto',
        paddingHorizontal: layout.paddingH,
        width: '100%',
    },
});
